export default __webpack_public_path__ + "static/media/aal.e3d83a20.svg";